// import React, { useMemo, useState } from "react";
// import {
//   View,
//   Text,
//   ScrollView,
//   TouchableOpacity,
//   Image,
//   Linking,
//   StyleSheet,
//   useWindowDimensions,
//   Platform,
// } from "react-native";
// import { MaterialIcons } from "@expo/vector-icons";
// import { LinearGradient } from "expo-linear-gradient";
// import { useNavigation } from "@react-navigation/native";
// import Header from "../components/Header";
// import { useTranslation } from "../i18n"; 

// const HomeScreen = () => {
//  const navigation = useNavigation();
//  const { t } = useTranslation();
//   const [darkMode] = useState(false);
//   const { width } = useWindowDimensions();

//   // ---- Breakpoints (tune if you want) ----
//   const isMobile = width < 520;
//   const isTablet = width >= 520 && width < 980;
//   const isDesktop = width >= 980;

//   // ---- Responsive spacing ----
//   const pagePadding = isMobile ? 16 : isTablet ? 24 : 40;
//   const sectionGap = isMobile ? 16 : 30;

//   // Colors based on theme
//   const colors = {
//     primary: "#008751",
//     primaryDark: "#006B41",
//     secondary: "#D92D20",
//     accent: "#FFD100",
//     backgroundLight: "#F8FAFC",
//     backgroundDark: "#0F172A",
//     surfaceLight: "#FFFFFF",
//     surfaceDark: "#1E293B",
//     textMainLight: "#1E293B",
//     textMainDark: "#E2E8F0",
//     textMutedLight: "#64748B",
//     textMutedDark: "#94A3B8",
//     gray100: "#F3F4F6",
//     gray200: "#E5E7EB",
//     gray700: "#374151",
//     gray800: "#1F2937",
//   };

//   const currentColors = darkMode
//     ? {
//         background: colors.backgroundDark,
//         surface: colors.surfaceDark,
//         textMain: colors.textMainDark,
//         textMuted: colors.textMutedDark,
//         border: colors.gray700,
//       }
//     : {
//         background: colors.backgroundLight,
//         surface: colors.surfaceLight,
//         textMain: colors.textMainLight,
//         textMuted: colors.textMutedLight,
//         border: colors.gray200,
//       };

//   const handleCall = (phoneNumber) => Linking.openURL(`tel:${phoneNumber}`);

//   // ---- Responsive styles computed ----
//   const S = useMemo(() => {
//     const heroHeight = isMobile ? 620 : isTablet ? 680 : 700;

//     const logoSize = isMobile ? 90 : isTablet ? 120 : 180;
//     const badgeSize = isMobile ? 88 : 120;

//     const titleSize = isMobile ? 30 : isTablet ? 40 : 48;
//     const subtitleSize = isMobile ? 22 : isTablet ? 28 : 32;

//     const sectionTitleSize = isMobile ? 22 : isTablet ? 28 : 32;

//     const gridDirection = isMobile ? "column" : "row";
//     const gridWrap = isMobile ? "nowrap" : "wrap";

//     const partnerWrap = isMobile ? "wrap" : "nowrap";

//     return StyleSheet.create({
//       container: { flex: 1 },

//       // Header
//       header: {
//         paddingHorizontal: pagePadding,
//         paddingVertical: isMobile ? 12 : 16,
//         borderBottomWidth: 2,
//         borderBottomColor: "#E5E7EB",
//       },
//       headerContent: {
//         flexDirection: "row",
//         alignItems: "center",
//         justifyContent: "space-between",
//         gap: isMobile ? 12 : 0,
//       },
//       logoContainer: { flexDirection: "row", alignItems: "center" },
//       logoImage: { width: logoSize, height: logoSize },
//       cuyLogo: { width: logoSize, height: logoSize },

//       // Hero
//       heroContainer: {
//         overflow: "hidden",
//         marginBottom: isMobile ? 24 : 40,
//         height: heroHeight,
//       },
//       heroBackground: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
//       taxiBackgroundImage: { width: "100%", height: "100%" },
//       blackOverlay: {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.7)",
//       },
//       heroContent: {
//         paddingHorizontal: pagePadding,
//         paddingTop: isMobile ? 28 : 60,
//         paddingBottom: isMobile ? 28 : 60,
//         alignItems: "center",
//         flex: 1,
//         justifyContent: "space-between",
//       },
//       cuyBadge: { alignItems: "center", marginBottom: isMobile ? 12 : 30 },
//       cuyBadgeImage: { width: badgeSize, height: badgeSize },

//       urgentBadge: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 12,
//         backgroundColor: "rgba(255, 255, 255, 0.95)",
//         borderWidth: 2,
//         borderColor: "#D92D20",
//         borderRadius: 30,
//         paddingHorizontal: 24,
//         paddingVertical: 12,
//         marginBottom: isMobile ? 12 : 20,
//       },
//       pingContainer: {
//         width: 20,
//         height: 20,
//         alignItems: "center",
//         justifyContent: "center",
//       },
//       dot: {
//         width: 10,
//         height: 10,
//         borderRadius: 5,
//         backgroundColor: "#D92D20",
//       },
//       urgentText: {
//         color: "#D92D20",
//         fontSize: 16,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 2,
//       },

//       mainTitle: {
//         fontSize: titleSize,
//         fontWeight: "900",
//         textAlign: "center",
//         lineHeight: titleSize + 4,
//         color: "#FFFFFF",
//         textShadowColor: "rgba(0, 0, 0, 0.8)",
//         textShadowOffset: { width: 0, height: 4 },
//         textShadowRadius: 8,
//         marginBottom: 8,
//       },
//       subtitle: {
//         fontSize: subtitleSize,
//         fontWeight: "800",
//         textAlign: "center",
//         lineHeight: subtitleSize + 4,
//         color: "#FFFFFF",
//         textShadowColor: "rgba(0, 0, 0, 0.6)",
//         textShadowOffset: { width: 0, height: 2 },
//         textShadowRadius: 4,
//         marginBottom: isMobile ? 12 : 24,
//       },
//       description: {
//         fontSize: isMobile ? 16 : 20,
//         textAlign: "center",
//         maxWidth: isMobile ? 360 : 600,
//         lineHeight: isMobile ? 22 : 28,
//         color: "rgba(255, 255, 255, 0.95)",
//         textShadowColor: "rgba(0, 0, 0, 0.5)",
//         textShadowOffset: { width: 0, height: 1 },
//         textShadowRadius: 2,
//         marginBottom: isMobile ? 14 : 32,
//       },

//       periodCard: {
//         width: "100%",
//         maxWidth: 500,
//         borderRadius: 20,
//         padding: isMobile ? 18 : 32,
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 12 },
//         shadowOpacity: 0.5,
//         shadowRadius: 24,
//         elevation: 16,
//         marginBottom: isMobile ? 14 : 40,
//       },
//       periodHeader: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 12,
//         marginBottom: 12,
//         opacity: 0.95,
//       },
//       periodLabel: {
//         color: "#FFFFFF",
//         fontSize: 14,
//         fontWeight: "700",
//         textTransform: "uppercase",
//         letterSpacing: 2,
//       },
//       periodDate: {
//         fontSize: isMobile ? 22 : 32,
//         color: "#FFFFFF",
//         fontWeight: "900",
//       },

//       // Sections
//       section: { paddingHorizontal: pagePadding, marginBottom: isMobile ? 28 : 60 },
//       sectionHeaderContainer: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 14,
//         marginBottom: isMobile ? 18 : 40,
//         paddingBottom: 16,
//         borderBottomWidth: 3,
//         borderBottomColor: colors.primary,
//         flexWrap: "wrap",
//       },
//       sectionMainTitle: {
//         fontSize: sectionTitleSize,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//       },

//       // CTA
//       mainCtaContainer: {
//         paddingHorizontal: pagePadding,
//         paddingBottom: isMobile ? 28 : 60,
//         alignItems: "center",
//       },
//       mainCtaButton: {
//         width: "100%",
//         maxWidth: 600,
//         borderRadius: 20,
//         overflow: "hidden",
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 8 },
//         shadowOpacity: 0.3,
//         shadowRadius: 16,
//         elevation: 12,
//       },
//       ctaGradient: {
//         flexDirection: "row",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 16,
//         paddingVertical: isMobile ? 16 : 24,
//         paddingHorizontal: isMobile ? 18 : 40,
//       },
//       mainCtaText: {
//         color: "#FFFFFF",
//         fontSize: isMobile ? 16 : 24,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         textAlign: "center",
//       },

//       // Cards grid (Who is concerned)
//       gridContainer: {
//         flexDirection: gridDirection,
//         gap: isMobile ? 16 : 40,
//         marginTop: 20,
//         flexWrap: gridWrap,
//       },
//       card: {
//         width: "100%",
//         flexGrow: 1,
//         flexBasis: isMobile ? "100%" : "46%",
//         padding: isMobile ? 18 : 40,
//         borderRadius: 20,
//         borderWidth: 3,
//         alignItems: "center",
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 8 },
//         shadowOpacity: 0.15,
//         shadowRadius: 16,
//         elevation: 8,
//       },
//       cardIconContainer: {
//         width: isMobile ? 78 : 100,
//         height: isMobile ? 78 : 100,
//         borderRadius: 999,
//         backgroundColor: "rgba(0, 135, 81, 0.1)",
//         alignItems: "center",
//         justifyContent: "center",
//         marginBottom: 18,
//       },
//       cardTitle: {
//         fontSize: isMobile ? 18 : 22,
//         fontWeight: "900",
//         textAlign: "center",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         marginBottom: 12,
//       },
//       cardDivider: { width: 80, height: 4, backgroundColor: colors.primary, marginBottom: 16 },
//       cardDescription: {
//         fontSize: isMobile ? 14 : 16,
//         textAlign: "center",
//         lineHeight: isMobile ? 20 : 24,
//       },

//       // Documents (2 columns on desktop, 1 on mobile)
//       documentsCard: {
//         borderRadius: 20,
//         borderWidth: 2,
//         borderColor: "#E5E7EB",
//         padding: isMobile ? 18 : 40,
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 12 },
//         shadowOpacity: 0.1,
//         shadowRadius: 24,
//         elevation: 12,
//       },
//       documentsGrid: {
//         flexDirection: isMobile ? "column" : "row",
//         gap: isMobile ? 18 : 40,
//       },
//       verticalDivider: {
//         width: isMobile ? 0 : 2,
//         height: isMobile ? 2 : "auto",
//         backgroundColor: "#E5E7EB",
//       },
//       documentColumn : {
//         flex: 1,
//       },
//       documentColumnHeader: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 12,
//         marginBottom: 18,
//         paddingBottom: 12,
//         borderBottomWidth: 2,
//         borderBottomColor: "#E5E7EB",
//         flexWrap: "wrap",
//       },
//       documentSectionTitle: {
//         fontSize: isMobile ? 16 : 20,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         color: colors.primary,
//         letterSpacing: 1,
//       },
//       documentItem: {
//         flexDirection: "row",
//         alignItems: "flex-start",
//         gap: 12,
//         marginBottom: 14,
//       },
//       documentText: {
//         fontSize: isMobile ? 14 : 18,
//         fontWeight: "600",
//         flex: 1,
//         lineHeight: isMobile ? 20 : 26,
//       },

//       // Why card
//       whyCard: {
//         borderRadius: 20,
//         padding: isMobile ? 18 : 40,
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 16 },
//         shadowOpacity: 0.3,
//         shadowRadius: 32,
//         elevation: 16,
//       },
//       whyHeader: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 14,
//         marginBottom: 18,
//         flexWrap: "wrap",
//       },
//       whyTitle: {
//         fontSize: isMobile ? 20 : 32,
//         color: "#FFFFFF",
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//       },
//       whyContent: { gap: 16 },
//       whyText: {
//         fontSize: isMobile ? 14 : 20,
//         color: "#FFFFFF",
//         lineHeight: isMobile ? 20 : 28,
//         fontWeight: "600",
//       },
//       whyPoints: { gap: 12 },
//       whyPoint: { flexDirection: "row", alignItems: "center", gap: 10 },
//       whyPointText: {
//         fontSize: isMobile ? 14 : 18,
//         color: "#FFFFFF",
//         fontWeight: "500",
//         lineHeight: isMobile ? 20 : 24,
//         flexShrink: 1,
//       },

//       // Free banner
//       freeBanner: {
//         borderRadius: 20,
//         padding: isMobile ? 18 : 40,
//         overflow: "hidden",
//         alignItems: "center",
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 16 },
//         shadowOpacity: 0.4,
//         shadowRadius: 32,
//         elevation: 20,
//       },
//       freeBadge: {
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 12,
//         backgroundColor: "rgba(255, 255, 255, 0.2)",
//         borderRadius: 50,
//         paddingHorizontal: 18,
//         paddingVertical: 10,
//         marginBottom: 16,
//       },
//       freeBadgeText: {
//         color: "#FFFFFF",
//         fontSize: isMobile ? 14 : 18,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 2,
//       },
//       freeTitle: {
//         color: "#FFFFFF",
//         fontSize: isMobile ? 22 : 36,
//         fontWeight: "900",
//         textAlign: "center",
//         marginBottom: 10,
//         textTransform: "uppercase",
//       },
//       freeSubtitle: {
//         color: "#FECACA",
//         fontSize: isMobile ? 14 : 20,
//         textAlign: "center",
//         marginBottom: 16,
//         fontWeight: "600",
//       },
//       freeDescription: {
//         color: "#FFFFFF",
//         fontSize: isMobile ? 13 : 18,
//         textAlign: "center",
//         lineHeight: isMobile ? 18 : 28,
//         maxWidth: 800,
//       },

//       // Partners
//       partnersGrid: {
//         flexDirection: "row",
//         justifyContent: "space-between",
//         marginTop: 20,
//         gap: 14,
//         flexWrap: partnerWrap,
//       },
//       partnerCard: {
//         alignItems: "center",
//         padding: 18,
//         borderRadius: 16,
//         backgroundColor: "#F8FAFC",
//         minWidth: isMobile ? "47%" : 180,
//         flexGrow: isMobile ? 1 : 0,
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 4 },
//         shadowOpacity: 0.1,
//         shadowRadius: 8,
//         elevation: 4,
//       },
//       partnerIcon: {
//         width: 70,
//         height: 70,
//         borderRadius: 999,
//         backgroundColor: "rgba(0, 135, 81, 0.1)",
//         alignItems: "center",
//         justifyContent: "center",
//         marginBottom: 10,
//       },
//       partnerName: {
//         fontSize: 14,
//         fontWeight: "900",
//         color: colors.primary,
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         textAlign: "center",
//       },

//       // Final CTA
//       finalCtaButton: {
//         width: "100%",
//         borderRadius: 20,
//         overflow: "hidden",
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 12 },
//         shadowOpacity: 0.3,
//         shadowRadius: 24,
//         elevation: 16,
//         marginBottom: 18,
//       },
//       finalCtaGradient: {
//         flexDirection: isMobile ? "column" : "row",
//         alignItems: "center",
//         justifyContent: "space-between",
//         paddingVertical: isMobile ? 18 : 32,
//         paddingHorizontal: isMobile ? 16 : 40,
//         gap: isMobile ? 12 : 0,
//       },
//       finalCtaTextContainer: {
//         flex: 1,
//         alignItems: "center",
//         marginHorizontal: isMobile ? 0 : 30,
//       },
//       finalCtaMainText: {
//         color: "#FFFFFF",
//         fontSize: isMobile ? 18 : 28,
//         fontWeight: "900",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         marginBottom: 6,
//         textAlign: "center",
//       },
//       finalCtaSubText: {
//         color: "rgba(255, 255, 255, 0.9)",
//         fontSize: isMobile ? 12 : 16,
//         fontWeight: "500",
//         textAlign: "center",
//       },
//       footerNote: {
//         fontSize: 12,
//         textAlign: "center",
//         fontStyle: "italic",
//       },

//       // Footer
//       footer: {
//         borderTopWidth: 6,
//         paddingTop: 40,
//         paddingBottom: 34,
//         paddingHorizontal: pagePadding,
//       },
//       footerTitle: {
//         fontSize: isMobile ? 18 : 28,
//         color: "#FFFFFF",
//         textAlign: "center",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         marginBottom: 20,
//         fontWeight: "900",
//       },
//       contactsGrid: {
//         flexDirection: isMobile ? "column" : "row",
//         gap: 16,
//         marginBottom: 28,
//       },
//       contactCard: {
//         flex: 1,
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 16,
//         padding: 18,
//         borderRadius: 16,
//         shadowColor: "#000",
//         shadowOffset: { width: 0, height: 8 },
//         shadowOpacity: 0.3,
//         shadowRadius: 16,
//         elevation: 8,
//       },
//       contactIcon: {
//         width: 58,
//         height: 58,
//         borderRadius: 999,
//         backgroundColor: "rgba(255, 255, 255, 0.1)",
//         alignItems: "center",
//         justifyContent: "center",
//       },
//       contactInfo: { flex: 1 },
//       contactLabel: {
//         color: "#94A3B8",
//         fontSize: 12,
//         fontWeight: "700",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         marginBottom: 6,
//       },
//       contactNumber: {
//         color: "#FFFFFF",
//         fontSize: 16,
//         fontWeight: "900",
//         marginBottom: 2,
//       },
//       footerBottom: {
//         alignItems: "center",
//         paddingTop: 18,
//         borderTopWidth: 1,
//         borderTopColor: "#374151",
//       },
//       copyright: {
//         fontSize: 11,
//         color: "#94A3B8",
//         textAlign: "center",
//         textTransform: "uppercase",
//         letterSpacing: 1,
//         marginBottom: 8,
//         fontWeight: "700",
//       },
//       version: { fontSize: 11, color: "#64748B", textAlign: "center" },
//     });
//   }, [darkMode, isMobile, isTablet, isDesktop, width]);

//   return (
//     <ScrollView
//       style={[S.container, { backgroundColor: currentColors.background }]}
//       showsVerticalScrollIndicator={false}
//     >
//       {/* Header */}
//       {/* Use the extracted Header component */}
//       <Header backgroundColor={currentColors.surface} />

//       {/* Hero */}
//       <View style={[S.heroContainer, { backgroundColor: currentColors.surface }]}>
//         <View style={S.heroBackground}>
//           <Image
//             source={require(".././../assets/Taxis-1344x630.jpg")}
//             style={S.taxiBackgroundImage}
//             resizeMode="cover"
//           />
//           <View style={S.blackOverlay} />
//         </View>

//         <View style={S.heroContent}>
//           <View style={S.cuyBadge}>
//             <Image
//               source={require(".././../assets/CUY-black.png")}
//               style={S.cuyBadgeImage}
//               resizeMode="contain"
//             />
//           </View>
//            <Text style={S.mainTitle}>{t("home.title")}</Text> {/* Translated */}
//           <Text style={S.subtitle}>{t("home.subtitle")}</Text> {/* Translated */}

//           <Text style={S.description}>
//             Propriétaires et conducteurs, identifiez-vous pour moderniser le transport urbain.
//           </Text>
//         </View>
//       </View>

//       {/* Main CTA */}
//       <View style={S.mainCtaContainer}>
//         <TouchableOpacity style={S.mainCtaButton} activeOpacity={0.9} onPress={() => navigation.navigate("ownership_screen")}>
//           <LinearGradient
//             colors={["#008751", "#006B41"]}
//             style={S.ctaGradient}
//             start={{ x: 0, y: 0 }}
//             end={{ x: 1, y: 0 }}
//           >
//             <Text style={S.mainCtaText}>COMMENCER L&apos;IDENTIFICATION</Text>
//             <MaterialIcons name="arrow-forward" size={26} color="#FFFFFF" />
//           </LinearGradient>
//         </TouchableOpacity>
//       </View>

//       {/* Who is Concerned */}
//       <View style={S.section}>
//         <View style={S.sectionHeaderContainer}>
//           <MaterialIcons name="groups" size={34} color="#008751" />
//           <Text style={[S.sectionMainTitle, { color: "#008751" }]}>QUI EST CONCERNÉ ?</Text>
//         </View>

//         <View style={S.gridContainer}>
//           <LinearGradient
//             colors={[currentColors.surface, darkMode ? "#2D3748" : "#F8FAFC"]}
//             style={[S.card, { borderColor: "#008751" }]}
//           >
//             <View style={S.cardIconContainer}>
//               <MaterialIcons name="local-taxi" size={56} color="#008751" />
//             </View>
//             <Text style={[S.cardTitle, { color: "#008751" }]}>PROPRIÉTAIRE TAXI</Text>
//             <View style={S.cardDivider} />
//             <Text style={[S.cardDescription, { color: currentColors.textMuted }]}>
//               Détenteur du véhicule et des documents administratifs. Vous êtes responsable du permis de transport et de la mise en conformité.
//             </Text>
//           </LinearGradient>

//           <LinearGradient
//             colors={[currentColors.surface, darkMode ? "#2D3748" : "#F8FAFC"]}
//             style={[S.card, { borderColor: "#008751" }]}
//           >
//             <View style={S.cardIconContainer}>
//               <MaterialIcons name="person-pin" size={56} color="#008751" />
//             </View>
//             <Text style={[S.cardTitle, { color: "#008751" }]}>CONDUCTEUR TAXI</Text>
//             <View style={S.cardDivider} />
//             <Text style={[S.cardDescription, { color: currentColors.textMuted }]}>
//               Chauffeur en activité avec permis valide. Vous devez être en possession de vos documents de conduite professionnelle.
//             </Text>
//           </LinearGradient>
//         </View>
//       </View>

//       {/* Documents Required */}
//       <View style={S.section}>
//         <View
//           style={[
//             S.documentsCard,
//             { backgroundColor: currentColors.surface, borderLeftWidth: 6, borderLeftColor: "#008751" },
//           ]}
//         >
//           <View style={S.sectionHeaderContainer}>
//             <MaterialIcons name="folder-shared" size={34} color="#F97316" />
//             <Text style={[S.sectionMainTitle, { color: "#F97316" }]}>PIÈCES À FOURNIR</Text>
//           </View>

//           <View style={S.documentsGrid}>
//             <View style={{ flex: 1 }}>
//               <View style={S.documentColumnHeader}>
//                 <MaterialIcons name="person" size={22} color="#008751" />
//                 <Text style={S.documentSectionTitle}>POUR LE PROPRIÉTAIRE</Text>
//               </View>

//               {[
//                 "Carte Grise (Certificat d'Immatriculation)",
//                 "Licence de Transport",
//                 "Carte Bleue Professionnelle",
//                 "Impôt Libératoire",
//                 "Assurance Validée",
//               ].map((item, index) => (
//                 <View key={index} style={S.documentItem}>
//                   <MaterialIcons name="check-circle" size={22} color="#10B981" />
//                   <Text style={[S.documentText, { color: currentColors.textMain }]}>{item}</Text>
//                 </View>
//               ))}
//             </View>

//             <View style={S.verticalDivider} />

//             <View style={{ flex: 1 }}>
//               <View style={S.documentColumnHeader}>
//                 <MaterialIcons name="drive-eta" size={22} color="#008751" />
//                 <Text style={S.documentSectionTitle}>POUR LE CONDUCTEUR</Text>
//               </View>

//               {[
//                 "CNI (Carte Nationale d'Identité)",
//                 "Permis de Conduire Catégorie B",
//                 "Certificat de Capacité Professionnelle",
//                 "Permis de Séjour (pour étrangers)",
//                 "Photo d'Identité",
//               ].map((item, index) => (
//                 <View key={index} style={S.documentItem}>
//                   <MaterialIcons name="check-circle" size={22} color="#10B981" />
//                   <Text style={[S.documentText, { color: currentColors.textMain }]}>{item}</Text>
//                 </View>
//               ))}
//             </View>
//           </View>
//         </View>
//       </View>

//       {/* Why This Census */}
//       <View style={S.section}>
//         <LinearGradient
//           colors={["#008751", "#006B41"]}
//           style={S.whyCard}
//           start={{ x: 0, y: 0 }}
//           end={{ x: 1, y: 0 }}
//         >
//           <View style={S.whyHeader}>
//             <MaterialIcons name="help-outline" size={34} color="#FFFFFF" />
//             <Text style={S.whyTitle}>POURQUOI CE RECENSEMENT ?</Text>
//           </View>

//           <View style={S.whyContent}>
//             <Text style={S.whyText}>
//               Cette initiative stratégique de la Communauté Urbaine de Yaoundé vise à :
//             </Text>

//             <View style={S.whyPoints}>
//               {[
//                 "Assainir le secteur du transport urbain",
//                 "Garantir la sécurité des usagers",
//                 "Améliorer les conditions de travail des professionnels",
//                 "Digitaliser la gestion du parc automobile",
//                 "Créer une base de données fiable pour la planification",
//               ].map((point, index) => (
//                 <View key={index} style={S.whyPoint}>
//                   <MaterialIcons name="chevron-right" size={20} color="#FFFFFF" />
//                   <Text style={S.whyPointText}>{point}</Text>
//                 </View>
//               ))}
//             </View>
//           </View>
//         </LinearGradient>
//       </View>

//       {/* Free Process Banner */}
//       <View style={S.section}>
//         <LinearGradient
//           colors={["#DC2626", "#B91C1C", "#991B1B"]}
//           style={S.freeBanner}
//           start={{ x: 0, y: 0 }}
//           end={{ x: 1, y: 0 }}
//         >
//           <View style={S.freeBadge}>
//             <MaterialIcons name="verified" size={28} color="#FFFFFF" />
//             <Text style={S.freeBadgeText}>OFFICIEL</Text>
//           </View>
//           <Text style={S.freeTitle}>PROCESSUS 100% GRATUIT</Text>
//           <Text style={S.freeSubtitle}>
//             Aucune somme d&apos;argent n&apos;est exigée pour ce recensement officiel
//           </Text>
//           <Text style={S.freeDescription}>
//             Le recensement est un service public entièrement gratuit. Les agents habilités portent des badges
//             d&apos;identification officiels. Méfiez-vous des individus qui demandent de l&apos;argent.
//           </Text>
//         </LinearGradient>
//       </View>

//       {/* Partners */}
//       <View style={S.section}>
//         <View style={S.sectionHeaderContainer}>
//           <MaterialIcons name="handshake" size={34} color="#008751" />
//           <Text style={[S.sectionMainTitle, { color: "#008751" }]}>PARTENAIRES OFFICIELS</Text>
//         </View>

//         <View style={S.partnersGrid}>
//           {["MINHDU", "GIZ", "AFD", "UNION EUROPÉENNE"].map((partner, index) => (
//             <View key={index} style={S.partnerCard}>
//               <View style={S.partnerIcon}>
//                 <MaterialIcons name="business" size={30} color="#008751" />
//               </View>
//               <Text style={S.partnerName}>{partner}</Text>
//             </View>
//           ))}
//         </View>
//       </View>

//       {/* Final CTA */}
//       <View style={S.section}>
//         <TouchableOpacity style={S.finalCtaButton} activeOpacity={0.9} onPress={() => navigation.navigate("ownership_screen")}>
//           <LinearGradient
//             colors={["#008751", "#006B41"]}
//             style={S.finalCtaGradient}
//             start={{ x: 0, y: 0 }}
//             end={{ x: 1, y: 0 }}
//           >
//             <MaterialIcons name="fingerprint" size={30} color="#FFFFFF" />
//             <View style={S.finalCtaTextContainer}>
//               <Text style={S.finalCtaMainText}>JE M&apos;IDENTIFIE MAINTENANT</Text>
//               <Text style={S.finalCtaSubText}>Cliquez pour accéder au formulaire en ligne</Text>
//             </View>
//             <MaterialIcons name="arrow-forward" size={30} color="#FFFFFF" />
//           </LinearGradient>
//         </TouchableOpacity>

//         <Text style={[S.footerNote, { color: currentColors.textMuted }]}>
//           Service officiel de la Communauté Urbaine de Yaoundé • Sécurité des données garantie
//         </Text>
//       </View>

//       {/* Footer */}
//       <View
//         style={[
//           S.footer,
//           {
//             backgroundColor: darkMode ? "#111827" : "#1E293B",
//             borderTopColor: "#008751",
//           },
//         ]}
//       >
//         <Text style={S.footerTitle}>CONTACTS & ASSISTANCE</Text>

//         <View style={S.contactsGrid}>
//           <TouchableOpacity
//             style={[S.contactCard, { backgroundColor: "#2D3748" }]}
//             onPress={() => handleCall("691049564")}
//             activeOpacity={0.7}
//           >
//             <View style={S.contactIcon}>
//               <MaterialIcons name="phone" size={26} color="#FFFFFF" />
//             </View>
//             <View style={S.contactInfo}>
//               <Text style={S.contactLabel}>CUY - LIGNE DIRECTE</Text>
//               <Text style={S.contactNumber}>691 04 95 64</Text>
//               <Text style={S.contactNumber}>690 20 99 85</Text>
//             </View>
//           </TouchableOpacity>

//           <TouchableOpacity
//             style={[S.contactCard, { backgroundColor: "#2D3748" }]}
//             onPress={() => handleCall("694179383")}
//             activeOpacity={0.7}
//           >
//             <View style={S.contactIcon}>
//               <MaterialIcons name="groups" size={26} color="#FFFFFF" />
//             </View>
//             <View style={S.contactInfo}>
//               <Text style={S.contactLabel}>PRÉSIDENTS DES SYNDICATS</Text>
//               <Text style={S.contactNumber}>694 17 93 83</Text>
//               <Text style={S.contactNumber}>677 85 84 38</Text>
//             </View>
//           </TouchableOpacity>
//         </View>

//         <View style={S.footerBottom}>
//           <Text style={S.copyright}>
//             © 2026 COMMUNE URBAINE DE YAOUNDÉ • TOUS DROITS RÉSERVÉS
//           </Text>
//           <Text style={S.version}>Version 1.0 • Dernière mise à jour : Janvier 2026</Text>
//         </View>
//       </View>
//     </ScrollView>
//   );
// };

// export default HomeScreen;

import React, { useMemo, useState } from "react";
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Image,
  Linking,
  StyleSheet,
  useWindowDimensions,
   Pressable, // ✅ add this
  Platform,
} from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";
import Header from "../components/Header";
import { useTranslation } from "../i18n"; 




const HomeScreen = () => {
  const navigation = useNavigation();
  const { t } = useTranslation();
  const [darkMode] = useState(false);
  const { width } = useWindowDimensions();
  
  const getCurrentMonthYear = () => {
    const date = new Date();
    const monthIndex = date.getMonth(); // 0-11
    const year = date.getFullYear();
    
    // Get month name from translations
    const monthName = t(`months.${monthIndex}`);
    
    return {
      month: monthName,
      year: year
    };
  };

  const { month, year } = getCurrentMonthYear();


  // ---- Breakpoints (tune if you want) ----
  const isMobile = width < 520;
  const isTablet = width >= 520 && width < 980;
  const isDesktop = width >= 980;

  // ---- Responsive spacing ----
  const pagePadding = isMobile ? 16 : isTablet ? 24 : 40;
  const sectionGap = isMobile ? 16 : 30;

  // Colors based on theme
  const colors = {
    primary: "#008751",
    primaryDark: "#006B41",
    secondary: "#D92D20",
    accent: "#FFD100",
    backgroundLight: "#F8FAFC",
    backgroundDark: "#0F172A",
    surfaceLight: "#FFFFFF",
    surfaceDark: "#1E293B",
    textMainLight: "#1E293B",
    textMainDark: "#E2E8F0",
    textMutedLight: "#64748B",
    textMutedDark: "#94A3B8",
    gray100: "#F3F4F6",
    gray200: "#E5E7EB",
    gray700: "#374151",
    gray800: "#1F2937",
  };

  const currentColors = darkMode
    ? {
        background: colors.backgroundDark,
        surface: colors.surfaceDark,
        textMain: colors.textMainDark,
        textMuted: colors.textMutedDark,
        border: colors.gray700,
      }
    : {
        background: colors.backgroundLight,
        surface: colors.surfaceLight,
        textMain: colors.textMainLight,
        textMuted: colors.textMutedLight,
        border: colors.gray200,
      };

  const handleCall = (phoneNumber) => Linking.openURL(`tel:${phoneNumber}`);


  // ✅ Partner logos (clickable)
 const PARTNER_LOGOS = [
  {
    key: "transport",
    source: require("../../assets/transport.jpg"),
    url: "https://mintransports.cm/", // ✅ link added
  },
  {
    key: "minhdu",
    source: require("../../assets/minhdu.png"),
    url: "https://www.minhdu.gov.cm/mobilite-verte-move-yaounde-le-minhdu-la-cuy-et-les-partenaires-au-developpement-se-mobilisent-pour-la-mobilite-a-yaounde/",
  },
  
  {
    key: "move",
    source: require("../../assets/move.png"),
    url: "https://yaounde.tumidata.org/",
  },
  // {
  //   key: "eu",
  //   source: require("../../assets/european.png"),
  //   url: "https://www.eeas.europa.eu/delegations/cameroun/cameroun-le-gouvernement-et-ses-partenaires-annoncent-la-poursuite-des-activit%C3%A9s-pr%C3%A9paratoires-au_fr",
  // },
  // {
  //   key: "german",
  //   source: require("../../assets/german.png"),
  //   url: "https://www.giz.de/en",
  // },
  // {
  //   key: "france",
  //   source: require("../../assets/france.png"),
  //   url: "https://www.service-public.gouv.fr/",
  // },
  // {
  //   key: "giz",
  //   source: require("../../assets/giz.png"),
  //   url: "https://www.giz.de/en",
  // },
  // {
  //   key: "afd",
  //   source: require("../../assets/afd.png"),
  //   url: "https://www.afd.fr/fr",
  // },
];




  // ---- Responsive styles computed ----
  const S = useMemo(() => {
    const heroHeight = isMobile ? 620 : isTablet ? 680 : 700;

    const logoSize = isMobile ? 90 : isTablet ? 120 : 180;
    const badgeSize = isMobile ? 88 : 120;

    const titleSize = isMobile ? 30 : isTablet ? 40 : 48;
    const subtitleSize = isMobile ? 22 : isTablet ? 28 : 32;

    const sectionTitleSize = isMobile ? 22 : isTablet ? 28 : 32;

    const gridDirection = isMobile ? "column" : "row";
    const gridWrap = isMobile ? "nowrap" : "wrap";

    const partnerWrap = isMobile ? "wrap" : "nowrap";

    return StyleSheet.create({
      container: { flex: 1 },

      // Header
      header: {
        paddingHorizontal: pagePadding,
        paddingVertical: isMobile ? 12 : 16,
        borderBottomWidth: 2,
        borderBottomColor: "#E5E7EB",
      },
      headerContent: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: isMobile ? 12 : 0,
      },
      logoContainer: { flexDirection: "row", alignItems: "center" },
      logoImage: { width: logoSize, height: logoSize },
      cuyLogo: { width: logoSize, height: logoSize },

      // Hero
      heroContainer: {
        overflow: "hidden",
        marginBottom: isMobile ? 24 : 40,
        height: heroHeight,
      },
      heroBackground: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
      taxiBackgroundImage: { width: "100%", height: "100%" },
      blackOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      },
      heroContent: {
        paddingHorizontal: pagePadding,
        paddingTop: isMobile ? 28 : 60,
        paddingBottom: isMobile ? 28 : 60,
        alignItems: "center",
        flex: 1,
        justifyContent: "space-between",
      },
      cuyBadge: { alignItems: "center", marginBottom: isMobile ? 12 : 30 },
      cuyBadgeImage: { width: badgeSize, height: badgeSize },

      urgentBadge: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        borderWidth: 2,
        borderColor: "#D92D20",
        borderRadius: 30,
        paddingHorizontal: 24,
        paddingVertical: 12,
        marginBottom: isMobile ? 12 : 20,
      },
      pingContainer: {
        width: 20,
        height: 20,
        alignItems: "center",
        justifyContent: "center",
      },
      dot: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: "#D92D20",
      },
      urgentText: {
        color: "#D92D20",
        fontSize: 16,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 2,
      },

      mainTitle: {
        fontSize: titleSize,
        fontWeight: "900",
        textAlign: "center",
        lineHeight: titleSize + 4,
        color: "#FFFFFF",
        textShadowColor: "rgba(0, 0, 0, 0.8)",
        textShadowOffset: { width: 0, height: 4 },
        textShadowRadius: 8,
        marginBottom: 8,
      },
      subtitle: {
        fontSize: subtitleSize,
        fontWeight: "800",
        textAlign: "center",
        lineHeight: subtitleSize + 4,
        color: "#FFFFFF",
        textShadowColor: "rgba(0, 0, 0, 0.6)",
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 4,
        marginBottom: isMobile ? 12 : 24,
      },
      description: {
        fontSize: isMobile ? 16 : 20,
        textAlign: "center",
        maxWidth: isMobile ? 360 : 600,
        lineHeight: isMobile ? 22 : 28,
        color: "rgba(255, 255, 255, 0.95)",
        textShadowColor: "rgba(0, 0, 0, 0.5)",
        textShadowOffset: { width: 0, height: 1 },
        textShadowRadius: 2,
        marginBottom: isMobile ? 14 : 32,
      },

      periodCard: {
        width: "100%",
        maxWidth: 500,
        borderRadius: 20,
        padding: isMobile ? 18 : 32,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 12 },
        shadowOpacity: 0.5,
        shadowRadius: 24,
        elevation: 16,
        marginBottom: isMobile ? 14 : 40,
      },
      periodHeader: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        marginBottom: 12,
        opacity: 0.95,
      },
      periodLabel: {
        color: "#FFFFFF",
        fontSize: 14,
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: 2,
      },
      periodDate: {
        fontSize: isMobile ? 22 : 32,
        color: "#FFFFFF",
        fontWeight: "900",
      },

      // Sections
      section: { paddingHorizontal: pagePadding, marginBottom: isMobile ? 28 : 60 },
      sectionHeaderContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 14,
        marginBottom: isMobile ? 18 : 40,
        paddingBottom: 16,
        borderBottomWidth: 3,
        borderBottomColor: colors.primary,
        flexWrap: "wrap",
      },
      sectionMainTitle: {
        fontSize: sectionTitleSize,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 1,
      },

      // CTA
      mainCtaContainer: {
        paddingHorizontal: pagePadding,
        paddingBottom: isMobile ? 28 : 60,
        alignItems: "center",
      },
      mainCtaButton: {
        width: "100%",
        maxWidth: 600,
        borderRadius: 20,
        overflow: "hidden",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 0.3,
        shadowRadius: 16,
        elevation: 12,
      },
      ctaGradient: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        paddingVertical: isMobile ? 16 : 24,
        paddingHorizontal: isMobile ? 18 : 40,
      },
      mainCtaText: {
        color: "#FFFFFF",
        fontSize: isMobile ? 16 : 24,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 1,
        textAlign: "center",
      },

      // Cards grid (Who is concerned)
      gridContainer: {
        flexDirection: gridDirection,
        gap: isMobile ? 16 : 40,
        marginTop: 20,
        flexWrap: gridWrap,
      },
      card: {
        width: "100%",
        flexGrow: 1,
        flexBasis: isMobile ? "100%" : "46%",
        padding: isMobile ? 18 : 40,
        borderRadius: 20,
        borderWidth: 3,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 0.15,
        shadowRadius: 16,
        elevation: 8,
      },
      cardIconContainer: {
        width: isMobile ? 78 : 100,
        height: isMobile ? 78 : 100,
        borderRadius: 999,
        backgroundColor: "rgba(0, 135, 81, 0.1)",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 18,
      },
      cardTitle: {
        fontSize: isMobile ? 18 : 22,
        fontWeight: "900",
        textAlign: "center",
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 12,
      },
      cardDivider: { width: 80, height: 4, backgroundColor: colors.primary, marginBottom: 16 },
      cardDescription: {
        fontSize: isMobile ? 14 : 16,
        textAlign: "center",
        lineHeight: isMobile ? 20 : 24,
      },

      // Documents (2 columns on desktop, 1 on mobile)
      documentsCard: {
        borderRadius: 20,
        borderWidth: 2,
        borderColor: "#E5E7EB",
        padding: isMobile ? 18 : 40,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 12 },
        shadowOpacity: 0.1,
        shadowRadius: 24,
        elevation: 12,
      },
      documentsGrid: {
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 18 : 40,
      },
      verticalDivider: {
        width: isMobile ? 0 : 2,
        height: isMobile ? 2 : "auto",
        backgroundColor: "#E5E7EB",
      },
      documentColumn : {
        flex: 1,
      },
      documentColumnHeader: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        marginBottom: 18,
        paddingBottom: 12,
        borderBottomWidth: 2,
        borderBottomColor: "#E5E7EB",
        flexWrap: "wrap",
      },
      documentSectionTitle: {
        fontSize: isMobile ? 16 : 20,
        fontWeight: "900",
        textTransform: "uppercase",
        color: colors.primary,
        letterSpacing: 1,
      },
      documentItem: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 12,
        marginBottom: 14,
      },
      documentText: {
        fontSize: isMobile ? 14 : 18,
        fontWeight: "600",
        flex: 1,
        lineHeight: isMobile ? 20 : 26,
      },

      // Why card
      whyCard: {
        borderRadius: 20,
        padding: isMobile ? 18 : 40,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 16 },
        shadowOpacity: 0.3,
        shadowRadius: 32,
        elevation: 16,
      },
      whyHeader: {
        flexDirection: "row",
        alignItems: "center",
        gap: 14,
        marginBottom: 18,
        flexWrap: "wrap",
      },
      whyTitle: {
        fontSize: isMobile ? 20 : 32,
        color: "#FFFFFF",
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 1,
      },
      whyContent: { gap: 16 },
      whyText: {
        fontSize: isMobile ? 14 : 20,
        color: "#FFFFFF",
        lineHeight: isMobile ? 20 : 28,
        fontWeight: "600",
      },
      whyPoints: { gap: 12 },
      whyPoint: { flexDirection: "row", alignItems: "center", gap: 10 },
      whyPointText: {
        fontSize: isMobile ? 14 : 18,
        color: "#FFFFFF",
        fontWeight: "500",
        lineHeight: isMobile ? 20 : 24,
        flexShrink: 1,
      },

      // Free banner
      freeBanner: {
        borderRadius: 20,
        padding: isMobile ? 18 : 40,
        overflow: "hidden",
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 16 },
        shadowOpacity: 0.4,
        shadowRadius: 32,
        elevation: 20,
      },
      freeBadge: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        borderRadius: 50,
        paddingHorizontal: 18,
        paddingVertical: 10,
        marginBottom: 16,
      },
      freeBadgeText: {
        color: "#FFFFFF",
        fontSize: isMobile ? 14 : 18,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 2,
      },
      freeTitle: {
        color: "#FFFFFF",
        fontSize: isMobile ? 22 : 36,
        fontWeight: "900",
        textAlign: "center",
        marginBottom: 10,
        textTransform: "uppercase",
      },
      freeSubtitle: {
        color: "#FECACA",
        fontSize: isMobile ? 14 : 20,
        textAlign: "center",
        marginBottom: 16,
        fontWeight: "600",
      },
      freeDescription: {
        color: "#FFFFFF",
        fontSize: isMobile ? 13 : 18,
        textAlign: "center",
        lineHeight: isMobile ? 18 : 28,
        maxWidth: 800,
      },

partnersBannerWrap: {
  alignSelf: "center",
  width: "100%",
  maxWidth: 980,
  borderRadius: 18,
  overflow: "hidden",
  backgroundColor: "#fff",
},

partnersBannerImage: {
  width: "100%",
  height: undefined,
  aspectRatio: 653 / 192, // ✅ keeps correct height automatically
},



      // Final CTA
      finalCtaButton: {
        width: "100%",
        borderRadius: 20,
        overflow: "hidden",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 12 },
        shadowOpacity: 0.3,
        shadowRadius: 24,
        elevation: 16,
        marginBottom: 18,
      },
      finalCtaGradient: {
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: isMobile ? 18 : 32,
        paddingHorizontal: isMobile ? 16 : 40,
        gap: isMobile ? 12 : 0,
      },
      finalCtaTextContainer: {
        flex: 1,
        alignItems: "center",
        marginHorizontal: isMobile ? 0 : 30,
      },
      finalCtaMainText: {
        color: "#FFFFFF",
        fontSize: isMobile ? 18 : 28,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 6,
        textAlign: "center",
      },
      finalCtaSubText: {
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: isMobile ? 12 : 16,
        fontWeight: "500",
        textAlign: "center",
      },
      footerNote: {
        fontSize: 12,
        textAlign: "center",
        fontStyle: "italic",
      },






      

// ✅ OFFICIAL PARTNERS (full width, single row, green)
partnersBannerOuter: {
  paddingHorizontal: pagePadding,
  marginTop: 10,
  marginBottom: 26,
},

partnersBannerCard: {
  width: "100%",          
  borderRadius: 20,
  overflow: "hidden",
  backgroundColor: "#DC2626", 
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 18 },
  shadowOpacity: 0.20,
  shadowRadius: 30,
  elevation: 16,
},

partnersBannerInner: {
  paddingVertical: isMobile ? 18 : 22,
  paddingHorizontal: isMobile ? 14 : 80,
},

partnersBannerTitle: {
  fontSize: isMobile ? 16 : 18,
  fontWeight: "900",
  color: "#FFFFFF",
  textTransform: "uppercase",
  letterSpacing: 2,
  textAlign: "center",
  marginBottom: isMobile ? 14 : 28,
},

// ✅ single horizontal row (NO WRAP)
partnersRow: {
  
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "space-around",
  alignItems: "center",
},

// ✅ logo tiles shrink depending on screen width
partnerLogoBtn: {
  flex: 1,
  maxWidth: isMobile ? 70 : isTablet ? 90 : 120, // ✅ prevents huge tiles
  height: isMobile ? 60 : isTablet ? 66 : 72,
  borderRadius: 15,

  backgroundColor: "rgba(255, 255, 255, 1)",
  borderWidth: 1,
  borderColor: "rgba(255, 255, 255, 0.94)",

  alignItems: "center",
  justifyContent: "center",

  marginHorizontal: isMobile ? 5 : 7,

  shadowColor: "#000",
  shadowOffset: { width: 0, height: 10 },
  shadowOpacity: 0.14,
  shadowRadius: 18,
  elevation: 10,
},


partnerLogoImg: {
  width: "82%",
  height: "82%",
},






      // Footer
      footer: {
        borderTopWidth: 6,
        paddingTop: 40,
        paddingBottom: 34,
        paddingHorizontal: pagePadding,
      },
      footerTitle: {
        fontSize: isMobile ? 18 : 28,
        color: "#FFFFFF",
        textAlign: "center",
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 20,
        fontWeight: "900",
      },
      contactsGrid: {
        flexDirection: isMobile ? "column" : "row",
        gap: 16,
        marginBottom: 28,
      },
      contactCard: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        gap: 16,
        padding: 18,
        borderRadius: 16,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 0.3,
        shadowRadius: 16,
        elevation: 8,
      },
      contactIcon: {
        width: 58,
        height: 58,
        borderRadius: 999,
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        alignItems: "center",
        justifyContent: "center",
      },
      contactInfo: { flex: 1 },
      contactLabel: {
        color: "#94A3B8",
        fontSize: 12,
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 6,
      },
      contactNumber: {
        color: "#FFFFFF",
        fontSize: 16,
        fontWeight: "900",
        marginBottom: 2,
      },
      footerBottom: {
        alignItems: "center",
        paddingTop: 18,
        borderTopWidth: 1,
        borderTopColor: "#374151",
      },
      copyright: {
        fontSize: 11,
        color: "#94A3B8",
        textAlign: "center",
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 8,
        fontWeight: "700",
      },
      version: { fontSize: 11, color: "#64748B", textAlign: "center" },
    });
  }, [darkMode, isMobile, isTablet, isDesktop, width]);

  return (
    <ScrollView
      style={[S.container, { backgroundColor: currentColors.background }]}
      showsVerticalScrollIndicator={false}
    >
      {/* Header */}
      <Header backgroundColor={currentColors.surface} />

      {/* Hero */}
      <View style={[S.heroContainer, { backgroundColor: currentColors.surface }]}>
        <View style={S.heroBackground}>
          <Image
            source={require(".././../assets/Taxis-1344x630.jpg")}
            style={S.taxiBackgroundImage}
            resizeMode="cover"
          />
          <View style={S.blackOverlay} />
        </View>

        <View style={S.heroContent}>
          <View style={S.cuyBadge}>
            <Image
              source={require(".././../assets/taxilogo.png")}
              style={S.cuyBadgeImage}
              resizeMode="contain"
            />
          </View>

          <Text style={S.mainTitle}>{t("home.title")}</Text>
          <Text style={S.subtitle}>{t("home.subtitle")}</Text>

          <Text style={S.description}>
            {t("home.description")}
          </Text>
        </View>
      </View>

      {/* Main CTA */}
      <View style={S.mainCtaContainer}>
        <TouchableOpacity style={S.mainCtaButton} activeOpacity={0.9} onPress={() => navigation.navigate("ownership_screen")}>
          <LinearGradient
            colors={["#008751", "#006B41"]}
            style={S.ctaGradient}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          >
            <Text style={S.mainCtaText}>{t("home.startIdentification")}</Text>
            <MaterialIcons name="arrow-forward" size={26} color="#FFFFFF" />
          </LinearGradient>
        </TouchableOpacity>
      </View>

      {/* Who is Concerned */}
      <View style={S.section}>
        <View style={S.sectionHeaderContainer}>
          <MaterialIcons name="groups" size={34} color="#008751" />
          <Text style={[S.sectionMainTitle, { color: "#008751" }]}>
            {t("home.whoIsConcerned")}
          </Text>
        </View>

        <View style={S.gridContainer}>
          <LinearGradient
            colors={[currentColors.surface, darkMode ? "#2D3748" : "#F8FAFC"]}
            style={[S.card, { borderColor: "#008751" }]}
          >
            <View style={S.cardIconContainer}>
              <MaterialIcons name="local-taxi" size={56} color="#008751" />
            </View>
            <Text style={[S.cardTitle, { color: "#008751" }]}>
              {t("home.ownerTitle")}
            </Text>
            <View style={S.cardDivider} />
            <Text style={[S.cardDescription, { color: currentColors.textMuted }]}>
              {t("home.ownerDescription")}
            </Text>
          </LinearGradient>

          <LinearGradient
            colors={[currentColors.surface, darkMode ? "#2D3748" : "#F8FAFC"]}
            style={[S.card, { borderColor: "#008751" }]}
          >
            <View style={S.cardIconContainer}>
              <MaterialIcons name="person-pin" size={56} color="#008751" />
            </View>
            <Text style={[S.cardTitle, { color: "#008751" }]}>
              {t("home.driverTitle")}
            </Text>
            <View style={S.cardDivider} />
            <Text style={[S.cardDescription, { color: currentColors.textMuted }]}>
              {t("home.driverDescription")}
            </Text>
          </LinearGradient>
        </View>
      </View>

      {/* Documents Required */}
      <View style={S.section}>
        <View
          style={[
            S.documentsCard,
            { backgroundColor: currentColors.surface, borderLeftWidth: 6, borderLeftColor: "#008751" },
          ]}
        >
          <View style={S.sectionHeaderContainer}>
            <MaterialIcons name="folder-shared" size={34} color="#F97316" />
            <Text style={[S.sectionMainTitle, { color: "#F97316" }]}>
              {t("home.documentsRequired")}
            </Text>
          </View>

          <View style={S.documentsGrid}>
            <View style={{ flex: 1 }}>
              <View style={S.documentColumnHeader}>
                <MaterialIcons name="person" size={22} color="#008751" />
                <Text style={S.documentSectionTitle}>
                  {t("home.forOwner")}
                </Text>
              </View>

              {t("home.ownerDocs").map((item, index) => (
                <View key={index} style={S.documentItem}>
                  <MaterialIcons name="check-circle" size={22} color="#10B981" />
                  <Text style={[S.documentText, { color: currentColors.textMain }]}>{item}</Text>
                </View>
              ))}
            </View>

            <View style={S.verticalDivider} />

            <View style={{ flex: 1 }}>
              <View style={S.documentColumnHeader}>
                <MaterialIcons name="drive-eta" size={22} color="#008751" />
                <Text style={S.documentSectionTitle}>
                  {t("home.forDriver")}
                </Text>
              </View>

              {t("home.driverDocs").map((item, index) => (
                <View key={index} style={S.documentItem}>
                  <MaterialIcons name="check-circle" size={22} color="#10B981" />
                  <Text style={[S.documentText, { color: currentColors.textMain }]}>{item}</Text>
                </View>
              ))}
            </View>
          </View>
        </View>
      </View>

      {/* Why This Census */}
      <View style={S.section}>
        <LinearGradient
          colors={["#008751", "#006B41"]}
          style={S.whyCard}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          <View style={S.whyHeader}>
            <MaterialIcons name="help-outline" size={34} color="#FFFFFF" />
            <Text style={S.whyTitle}>
              {t("home.whyCensus")}
            </Text>
          </View>

          <View style={S.whyContent}>
            <Text style={S.whyText}>
              {t("home.whyDescription")}
            </Text>

            <View style={S.whyPoints}>
              {t("home.whyPoints").map((point, index) => (
                <View key={index} style={S.whyPoint}>
                  <MaterialIcons name="chevron-right" size={20} color="#FFFFFF" />
                  <Text style={S.whyPointText}>{point}</Text>
                </View>
              ))}
            </View>
          </View>
        </LinearGradient>
      </View>

      {/* Free Process Banner */}
      <View style={S.section}>
        <LinearGradient
          colors={["#DC2626", "#B91C1C", "#991B1B"]}
          style={S.freeBanner}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          <View style={S.freeBadge}>
            <MaterialIcons name="verified" size={28} color="#FFFFFF" />
            <Text style={S.freeBadgeText}>{t("home.freeBadge")}</Text>
          </View>
          <Text style={S.freeTitle}>
            {t("home.freeProcess")}
          </Text>
          
          <Text style={S.freeDescription}>
            {t("home.freeDescription")}
          </Text>
        </LinearGradient>
      </View>

      {/* Partners */}
      <View style={S.section}>
        <View style={S.sectionHeaderContainer}>
          <MaterialIcons name="handshake" size={34} color="#008751" />
          <Text style={[S.sectionMainTitle, { color: "#008751" }]}>
            {t("home.officialPartners")}
          </Text>
        </View>


<View style={S.partnersBannerWrap}>
  <Image
    source={require("/assets/originallogos .png")
}
    style={S.partnersBannerImage}
    resizeMode="contain"
  />
</View>



      </View>

      {/* Final CTA */}
      <View style={S.section}>
        <TouchableOpacity style={S.finalCtaButton} activeOpacity={0.9} onPress={() => navigation.navigate("ownership_screen")}>
          <LinearGradient
            colors={["#008751", "#006B41"]}
            style={S.finalCtaGradient}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          >
            <MaterialIcons name="fingerprint" size={30} color="#FFFFFF" />
            <View style={S.finalCtaTextContainer}>
              <Text style={S.finalCtaMainText}>
                {t("home.identifyNow")}
              </Text>
              <Text style={S.finalCtaSubText}>
                {t("home.clickToAccess")}
              </Text>
            </View>
            <MaterialIcons name="arrow-forward" size={30} color="#FFFFFF" />
          </LinearGradient>
        </TouchableOpacity>

        <Text style={[S.footerNote, { color: currentColors.textMuted }]}>
          {t("home.footerNote")}
        </Text>
      </View>



{/* ✅ OFFICIAL PARTNERS (full width, one horizontal row) */}
<View style={S.partnersBannerOuter}>
  <View style={S.partnersBannerCard}>
    <View style={S.partnersBannerInner}>
      <Text style={S.partnersBannerTitle}>{t("home.moreInfoTitle")}</Text>
      <View style={S.partnersRow}>
        {PARTNER_LOGOS.map((item) => (
         <Pressable
  key={item.key}
  style={[
    S.partnerLogoBtn,
    !item.url && { opacity: 0.9 }, // optional visual cue
  ]}
  onPress={() => {
    if (item.url) {
      Linking.openURL(item.url);
    }
  }}
>
  <Image
    source={item.source}
    style={S.partnerLogoImg}
    resizeMode="contain"
  />
</Pressable>
        ))}
      </View>
    </View>
  </View>
</View>

      {/* Footer */}
      <View
        style={[
          S.footer,
          {
            backgroundColor: darkMode ? "#111827" : "#1E293B",
            borderTopColor: "#008751",
          },
        ]}
      >
        <Text style={S.footerTitle}>
          {t("home.contacts")}
        </Text>

        <View style={S.contactsGrid}>
          <TouchableOpacity
            style={[S.contactCard, { backgroundColor: "#2D3748" }]}
            onPress={() => handleCall("691049564")}
            activeOpacity={0.7}
          >
            <View style={S.contactIcon}>
              <MaterialIcons name="phone" size={26} color="#FFFFFF" />
            </View>
            <View style={S.contactInfo}>
              <Text style={S.contactLabel}>
                {t("home.cuyDirectLine")}
              </Text>
              <Text style={S.contactNumber}>691 04 95 64</Text>
              <Text style={S.contactNumber}>690 20 99 85</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity
            style={[S.contactCard, { backgroundColor: "#2D3748" }]}
            onPress={() => handleCall("676164117")}
            activeOpacity={0.7}
          >
            <View style={S.contactIcon}>
              <MaterialIcons name="groups" size={26} color="#FFFFFF" />
            </View>
            <View style={S.contactInfo}>
              <Text style={S.contactLabel}>
                {t("home.unionPresidents")}
              </Text>
              <Text style={S.contactNumber}>676 16 41 17</Text>
              <Text style={S.contactNumber}>656 96 02 80</Text>
            </View>
          </TouchableOpacity>
        </View>

        <View style={S.footerBottom}>
          <Text style={S.copyright}>
            {t("home.copyright")}
          </Text>
          <Text style={S.version}>{t("home.version").replace("{{month}}", month).replace("{{year}}", year)}</Text>
        </View>
      </View>
    </ScrollView>
      // <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
      //   {/* Header */}
      //   <Header backgroundColor={currentColors.surface} />
      //   <View
      //     style={{
      //       flex: 1,
      //       minHeight: 300,
      //       justifyContent: "center",
      //       alignItems: "center",
      //       paddingHorizontal: 24,
      //       paddingVertical: 32,
      //     }}
      //   >
      //     <Text
      //       style={{
      //         fontSize: 28,
      //         fontWeight: "700",
      //         textAlign: "center",
      //         color: currentColors.textMain,
      //       }}
      //     >
      //       {t("home.serviceNotAvailable")}
      //     </Text>
      //   </View>
      // </ScrollView>
  );
};

export default HomeScreen;